import { render, staticRenderFns } from "./InventorySlotSelector.vue?vue&type=template&id=064a41d6"
import script from "./InventorySlotSelector.vue?vue&type=script&lang=js"
export * from "./InventorySlotSelector.vue?vue&type=script&lang=js"
import style0 from "./InventorySlotSelector.vue?vue&type=style&index=0&id=064a41d6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports